import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
import TextUppercase from "./textUppercase";
var TextMeta = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement(TextUppercase, { className: cn(styles.textMeta, className) }, children));
};
export default TextMeta;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/text/textMeta.tsx
// module id = k0gy
// module chunks = 2